export default __webpack_public_path__ + "static/media/shopify.ce233da0.svg";